import { useState, useLayoutEffect  } from "react" 
import TreeView from "../meTree/TreeView.js"
import {meSplitter} from '../Shared/meGlobal.js'

import {Cookie} from '../Shared/Api.js'
import { DefaultControl } from "../Shared/ViewControl.js"

const Pages = ({search, connected, Etat}) => {
        //alert(connected)
        const waqafaat = "https://moshaf.akademy.ma/waqafaat/"

        const [selected, Selected] = useState(0)

        const [safha, Safha] = useState(waqafaat+'001.jpg')

        const splitter = new meSplitter("Side", "HomeContainer")

        //const [items, Items] = useState(splitter.items.length)

        useLayoutEffect (()=>{  // like useEffect but synchronously after all DOM
                Etat(`splitter ${splitter.items.length}`)
                splitter.selectorAll()

                let page = Cookie('meSafha') ?? 1
                onNode(page)
        },[])

        const onNode = (id) => {
                Selected(id)
                Etat(`Wajh ${id}`)
                let name = (id||0).toString().padStart(3,'0')+'.jpg'
                Safha(waqafaat+name)
        }

        const onSafha = (event) => {
                let cr = event.currentTarget.getBoundingClientRect()
        }

        return (
                connected ?
                <div className="Home" id="HomeContainer"
                onMouseDown={(e)=>{splitter.mouseDown(e)}} 
                onMouseMove={(e)=>{splitter.mouseMove(e)}} 
                onMouseUp={(e)=>{return splitter.mouseUp(e)}}>

                <div className="side" id="SideDetail">
                        <div style={{textAlign:'center', width:'100%', height:'100%'}}>
                        <img className="page-fit-center" alt="القرآن الكريم"  id="image" 
                        src={safha} 
                        onClick={onSafha}
                        /> 
                        </div>
                </div>

                <div className="side" id="SideTree">
                        <TreeView onChange={onNode} selected={selected} />
	        </div>
            </div>
            :
                <DefaultControl />
        
        )
}

export default Pages